module.exports = __webpack_public_path__ + "img/jmcd-banner-pic.2971941f.png";